export function replaceYearDeep<T>(value: T, year: string): T {
  if (typeof value === 'string') {
    return value.replace(/{YEAR}/g, year) as unknown as T;
  }
  if (Array.isArray(value)) {
    return value.map(item => replaceYearDeep(item, year)) as unknown as T;
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [
        key,
        replaceYearDeep(val, year),
      ]),
    ) as unknown as T;
  }
  return value;
}

export function currentYear(): string {
  return String(new Date().getFullYear());
}
